module.exports = __webpack_public_path__ + "img/honey.56837968.jpg";